import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

@Component({
    selector: 'sb-tooltip-info',
    standalone: true,
    imports: [CommonModule, TablerIconsModule, MatTooltipModule],
    template: `
        <tabler-icon
            *ngIf="tooltipText"
            class="align-self-center sb-icon-bold ms-1 my-n1 text-info"
            [class.sb-icon-xs]="size === 'xs'"
            [class.sb-icon-sm]="size === 'sm'"
            [class.sb-icon-md]="size === 'md'"
            name="info-circle"
            [matTooltip]="tooltipText"
        ></tabler-icon>
    `,
    styles: [
        `
            :host tabler-icon {
                vertical-align: middle;
            }
            :host {
                display: inherit;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SbTooltipInfoComponent {
    @Input() tooltipText: string | undefined;
    @Input() size: 'xs' | 'sm' | 'md' = 'sm';
}
